import dark from './dark';
import light from './light';

// These are app specific colors for edge cases where we need to
// change colors from components like `Box` and `Text`.
// `color` interface from styled-system has to be used.
// Should be string references for the actual colors from shopper
// Shopper color docs can be seen here:
// https://shopper-promobit.netlify.app/?path=/docs/tema-cores--page
const appTheme = {
  dark,
  light,
};

export default appTheme;
